import React from 'react';
import { Modal, Select, Alert } from 'antd';
import { useMergeSelection } from './auditDrawers.controller';

export default function AuditMergeModal({ open, onClose, group, onMerge, merging }) {
    const { products, canonicalId, setCanonicalId, handleOk } = useMergeSelection(group, onMerge);

    return (
        <Modal
            title="Fusionar productos duplicados"
            open={open}
            onCancel={onClose}
            onOk={handleOk}
            confirmLoading={merging}
            okText="Fusionar"
            cancelText="Cancelar"
            destroyOnClose>
            <Alert type="warning" showIcon className="mb-4" message="Los duplicados se desactivarán y sus escaneos se reasignarán al producto canónico." />
            {group?.reason && <p className="m-0 mb-4 text-sm text-surface-600">{group?.reason}</p>}
            <label className="flex flex-col gap-1">
                <span className="text-xs font-medium text-surface-500">Producto canónico (se conserva)</span>
                <Select
                    className="w-full"
                    value={canonicalId}
                    onChange={setCanonicalId}
                    options={products.map((p) => ({
                        value: p._id,
                        label: `${p.name} (${p.code})`,
                    }))}
                />
            </label>
        </Modal>
    );
}
